// Language menu logic
const toggleButton = document.getElementById("language-toggle");
const dropdownMenu = document.getElementById("language-menu");

toggleButton.addEventListener("click", (e) => {
  e.stopPropagation();
  dropdownMenu.classList.toggle("active");
  toggleButton.classList.toggle("active");
});

document.addEventListener("click", () => {
  dropdownMenu.classList.remove("active");
  toggleButton.classList.remove("active");
});

dropdownMenu.addEventListener("click", (e) => {
  e.stopPropagation();
});
